import {
  RESET_REPORT,
  SAVE_NEW_REPORT,
  UPDATE_REPORT_FILTERS,
  UPDATE_REPORTING_TYPE_IDS,
  CLEAR_REPORTING_TYPE_MODAL_IDS,
  METRICS_LIST_UPDATED,
  REPORT_PARAMS_UPDATED,
  FETCH_REPORT_BY_ID_RESPONSE,
  SAVE_REPORT_REQUEST,
  SAVE_REPORT_RESPONSE,
  SAVE_REPORT_ERROR,
  SELECT_HIGHCHARTS_TYPE,
  EXPORT_REPORT_DATA_AS_CSV_RESPONSE,
} from './actionTypes';
import { t as reportsTableTypes } from '../reportsTable';
import { ActiveMenuItemEnum } from './types';

const initialState = {
  activeReportId: -1,
  hasUnsavedChanges: false,
  reportDataAsCsv: '',
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case reportsTableTypes.RECEIVED_FILTERED_REPORTS:
      return {
        ...state,
        ...action.reports.reduce(
          (result, report) => ({
            ...result,
            [report.id]: {
              ...report,
              reportingTypeTable: [],
            },
          }),
          {},
        ),
      };
    case RESET_REPORT:
      return state;
    case SAVE_NEW_REPORT:
      return {
        ...state,
      };
    case UPDATE_REPORT_FILTERS:
      return {
        ...state,
        [action.filters.id]: {
          ...state[action.filters.id],
          ...action.filters,
        },
      };
    case CLEAR_REPORTING_TYPE_MODAL_IDS:
      return {
        ...state,
        reportingTypeModalIds: [],
      };
    case UPDATE_REPORTING_TYPE_IDS:
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          componentIds: action.ids,
        },
        hasUnsavedChanges: true,
      };
    case FETCH_REPORT_BY_ID_RESPONSE: {
      return {
        ...state,
        [action.report.id]: {
          ...action.report,
        },
        activeReportId: action.report.id,
      };
    }
    case METRICS_LIST_UPDATED: {
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          selectedMetrics: action.metricsList,
        },
        hasUnsavedChanges: true,
      };
    }
    case REPORT_PARAMS_UPDATED: {
      const { reportId, type, ...params } = action;
      return {
        ...state,
        [action.reportId]: {
          ...state[action.reportId],
          ...params,
        },
        hasUnsavedChanges: true,
      };
    }
    case SAVE_REPORT_REQUEST: {
      return {
        ...state,
        [action.report.id]: {
          ...state[action.report.id],
          saving: true,
        },
      };
    }
    case SAVE_REPORT_RESPONSE: {
      return {
        ...state,
        [action.report.id]: {
          ...state[action.report.id],
          saving: false,
        },
        hasUnsavedChanges: false,
      };
    }
    case SAVE_REPORT_ERROR: {
      return {
        ...state,
        [action.report.id]: {
          ...state[action.report.id],
          saving: false,
        },
      };
    }
    case EXPORT_REPORT_DATA_AS_CSV_RESPONSE: {
      return {
        ...state,
        reportDataAsCsv: action.csvData,
      };
    }
    case SELECT_HIGHCHARTS_TYPE: {
      const report = state[action.reportId];
      const activeView =
        action.dataView === ActiveMenuItemEnum.componentTable ? 'entityView' : 'dateTimeView';

      return {
        ...state,
        [action.reportId]: {
          ...report,
          settings: {
            ...report.settings,
            [activeView]: {
              ...report.settings[activeView],
              chartType: action.chartType,
            },
          },
        },
      };
    }
    case reportsTableTypes.REPORT_CREATED: {
      return {
        ...state,
        activeReportId: action.data.id,
      };
    }
    default: {
      return state;
    }
  }
};

export default reportReducer;
